import Browser from '../../../utils/pdf-print-js/browser';

export const safeToFixedDecimalScale = (decimalScale, value) => {
  if ((typeof value !== 'number' && typeof value !== 'string') || value === '') {
    return value;
  }

  if (value.toString().includes('e') && !Browser.isFirefox()) {
    return parseInt(value);
  }

  return decimalScale ? (+value).toFixed(decimalScale) : `${Math.trunc(value)}`;
};

export const getDisplayValue = ({ isFocused, hasValueChanged, decimalScale, localValue }) => {
  const result =
    isFocused && !hasValueChanged ? localValue : safeToFixedDecimalScale(decimalScale, localValue);

  return result === 'NaN' ? '' : result;
};
